import React, { StyleHTMLAttributes } from "react";
import { Container, Col, Row } from "reactstrap";
import { Section, SectionHead } from "../../layout/section/Section";
import { ResponsivePie } from "@nivo/pie";
import { CheckedCircle } from "../../components/styledList/StyledList";

const MyResponsivePie = ({ data, ...props }) => {

  const margin = { top: 0, right: 10, bottom: 60, left: 10 };

  const styles : any = {
    root: {
      fontFamily: "consolas, sans-serif",
      textAlign: "center",
      position: "relative",
      width: 600,
      height: 600,
    },
    overlay: {
      position: "absolute",
      top: 0,
      right: margin.right,
      bottom: 0,
      left: margin.left,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "3.5rem",
      // color: "#FFFFFF",
      background: "#FFFFFF33",
      textAlign: "center",
      // This is important to preserve the chart interactivity
      pointerEvents: "none",
    },
    totalLabel: {
      fontSize: "0.3em",
    },
  };

  return (
    <>
    <ResponsivePie
      data={data}
      margin={margin}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      valueFormat=" >-.0%"
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      colors={{ datum: "data.color" }}
      enableArcLinkLabels={false}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={"#fff"}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: "#999",
          itemDirection: "left-to-right",
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemTextColor: "#000",
              },
            },
          ],
        },
      ]}
    />
    <div style={styles.overlay}>
      <span style={styles.totalLabel}>Your Overall Score</span>
      <span>{props.OverallScore}%</span>
    </div></>
  );
};


const Intro = (props : any) => {
  return (
    <>
      <Section
        className={props.className && props.className}
        id={props.id && props.id}
      >
        <Container>
        <Row className="text-left">
            <Col lg="12">
              <SectionHead>
                <h2 className="title">
                  Thank you for completing the{" "}
                  <strong>DE&amp;I Scorecard</strong>
                </h2>
                </SectionHead>
            </Col>
          </Row>
          <Row className="text-left">
            <Col sm="12" lg="7">
              <SectionHead>
                <p>Your full report has been emailed to {props.Email}.</p>
                <p>
                There is no one-size-fits-all when it comes to Diversity, Equity & Inclusion strategies. Instead, it is an iterative journey that involves trialling various strategies and systematically measuring the impact to establish which ones work for the company.
                
                That said, well-executed strategies lead to better results. This is why we assess organisations on 3 key areas.
                </p>
                <CheckedCircle
                  className="list-lg list-purple list-checked-circle pt-1"
                  data={[
                    'Data Collection & Analysis: Uncover the problems inherent to your organisation',
                    'Frameworks: Guide your analysis and facilitate disclosures',
                    'Strategy: Take data-driven action points with measurable impact',
                  ]}
                />
                <br />
                <p>Here's how you score against these four key criteria:</p>
                <ul style={{ display: "inline" }}>
                  <li style={{ display: "inline" }} className="pl-3">
                    <span className="badge badge-dot badge-xl badge-danger">
                      {" "}
                    </span>
                    <strong>
                    Beginner (If you score 0-33%)
                    </strong>
                  </li>
                  <br></br>
                  <li style={{ display: "inline" }} className="pl-3">
                    <span className="badge badge-dot badge-xl badge-warning">
                      {" "}
                    </span>
                    <strong>
                    Intermediate (If you Score 34-67%)
                    </strong>
                  </li>
                  <br></br>
                  <li style={{ display: "inline" }} className="pl-3">
                    <span className="badge badge-dot badge-xl badge-success">
                      {" "}
                    </span>
                    <strong>
                    Expert (If you Score 68-100%)
                    </strong>
                  </li>
                </ul>
              </SectionHead>
            </Col>
            <Col sm="12" lg="5" style={{minHeight: "533px"}}>
              <MyResponsivePie data={props.data} OverallScore={props.OverallScore} />
            </Col>
          </Row>
        </Container>
      </Section>
      <Container className="section-service pb-0" id="#service">
        <Row className="justify-content-center text-center">
          <Col sm="8" lg="6">
            <SectionHead>
              <h2 className="title">Let's explore your score further:</h2>
            </SectionHead>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Intro;
